import React from "react";
import { useCallback } from "react";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import makeStyles from "@material-ui/core/styles/makeStyles";
import SchoolForm from "../../components/admin/SchoolForm";
import { createSchoolFormValidator } from "../../validators";
import arrayMutators from "final-form-arrays";
import { Form } from "react-final-form";
import { AdapterLink } from "../../../../components/Adopter";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import useSchoolQueries from "../../hooks/useSchoolQueries";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
}));

export function CreatePage() {
  const classes = useStyles();
  const { fetchCreate } = useSchoolQueries();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const create = useCallback(
    async (data) => {
      try {
        await fetchCreate(data);
        history.push(`/0/${Routes.SCHOOLS}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchCreate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/school">Schools</AdapterLink>
        <Typography color="textPrimary">Create</Typography>
      </Breadcrumbs>
      <Paper>
        <Form
          onSubmit={create}
          validate={createSchoolFormValidator}
          mutators={{
            ...arrayMutators,
          }}
          component={SchoolForm}
        />
      </Paper>
    </Container>
  );
}

export default CreatePage;
